export enum PRODUCT_STATUS {
  IDLE = 'idle',
  REMOVING = 'removing',
}
